<template>
	<div>
		<Banner :url="detail.cover">
			<div class="t">{{ detail.name }}</div>
		</Banner>
		<div class="detail">
			<!-- <div class="title">景点介绍</div>
      <div class="sub-title">景区介绍</div> -->
			<div v-html="detail.scenicContent"></div>

			<!-- <div class="sub-title">参观时间</div>
      <div class="sub-title">门票信息</div>
      <div class="sub-title">交通攻略</div> -->
		</div>
	</div>
</template>

<script>
	import Banner from "../Home/banner";
	import {
		mapState
	} from "vuex";
	export default {
		components: {
			Banner
		},
		data() {
			return {
				info: {},
			};
		},
		computed: {
			...mapState(["detail"]),
		},
	};
</script>

<style lang="scss" scoped>
	.detail {

		// padding: 30px;
		&::v-deep {
			img {
				width: 100% !important;
			}
		}
	}

	.t {
		font-size: 30px;
		color: #fff;
		padding: 33px 40px;
		font-weight: 500;
	}

	.title {
		font-size: 36px;
		font-weight: bold;
	}

	.sub-title {
		font-size: 32px;
		font-weight: bold;
		margin-top: 49px;
		margin-bottom: 39px;
	}
</style>
